import routerOptions0 from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.1_@types+node@25.9.1_db0@0.2.4_eslint@9.14.0_jiti@2.4.2__iore_gw4d4udegl3jeabtn5rtub3y6a/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}